import { render, staticRenderFns } from "./EntradaTrasladoTableComponent.vue?vue&type=template&id=773fa272&"
import script from "./EntradaTrasladoTableComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaTrasladoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports